import { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import {
  Border,
  Card,
  Grid,
  Icon,
  Placeholder,
  Screen,
  Scrollbar,
  Sizes,
  Spacing,
  Button as ThemeButton,
  Color as ThemeColor,
  Components as ThemeComponents,
  Form as ThemeForm,
  Modal as ThemeModal,
  Transition,
  Typography,
  ZIndex,
} from '../theme';

export {
  Border,
  Card,
  Grid,
  Icon,
  Placeholder,
  Screen,
  Scrollbar,
  Sizes,
  Spacing,
  Transition,
  Typography,
  ZIndex,
};

export const Color = {
  ...ThemeColor,
  Brand: {
    Primary: '#6659E3',
    Dark: '#000000',
    Darkest: '#2B373F',
    Light: '#0a0917',
    Lightest: '#070610',
    Special: '#56CF7D',
    SpecialDark: '#47AB67',
  },

  System: {
    Primary: '#3249FF',
    Dark: '#222F99',
    Light: '#16193E',
    Lightest: '#131427',
    Success: '#49AA19',
  },

  Neutrals: {
    Dark: '#FFFFFF',
    Text: 'rgba(255, 255, 255, 0.85)',
    Border: '#333333',
    Light: '#1F1F1F',
    Gray: 'rgba(255, 255, 255, 0.45)',
    Paper: '#0A0A0A',
    Surface: '#2A2A2A',
  },

  Feedback: {
    Alert: '#DC4446',
    AlertLight: '#2C1618',
    Success: '#49AA19',
    SuccessLight: '#162312',
    Warning: '#D89614',
    WarningLight: '#2B2111',
    Info: '#3249FF',
    InfoLight: '#131427',
    InfoSpecial: '#536AED',
  },

  Overlay: {
    Light: 'rgba(255,255,255,0.18)',
    Default: 'rgba(255, 255, 255, 0.45)',
    Hover: 'rgba(255, 255, 255, 0.85)',
  },
};

export const Components = {
  ...ThemeComponents,
  Empty: {
    ...ThemeComponents.Empty,
  },
  Folder: {
    ...ThemeComponents.Folder,
    Color: {
      Background: Color.System.Primary,
      Title: Color.Neutrals.Dark,
      Subtitle: Color.Neutrals.Gray,
    },
    IconWrapper: 'folder-black---46',
  },
  Skeleton: {
    Color: {
      Dark: 'rgba(255, 255, 255, 0.12)',
      Light: 'rgba(255, 255, 255, 0.18)',
    },
    Animation: {
      Gradient: {
        Start: 25,
        Center: 37,
        End: 63,
      },
      Background: 400,
    },

    Section: {
      ...ThemeComponents.Section,
      Icons: {
        Highlight: 'effect-highlight-dark---48',
        Underline: 'effect-underline-dark---48',
        LineThrough: 'effect-line-through-dark---48',
        Stroke: 'effects-stroke-dark---48',
      },
    },
  },

  Tooltip: {
    Color: {
      Background: Color.Neutrals.Surface,
      Text: Color.Neutrals.Text,
    },
  },

  Background: Color.NeutralsFixed.Dark,

  Logo: {
    Color: Color.Neutrals.Dark,
    Size: ThemeComponents.Logo.Size,
  },

  Panel: {
    Background: Color.Neutrals.Light,
    BackgroundHover: Color.Neutrals.Border,
    Divider: {
      Color: Color.Neutrals.Border,
    },
  },
  AiAssistant: {
    ...ThemeComponents.AiAssistant,
    Background: css`
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      background-color: rgba(255, 255, 255, 0.16);
      border: ${utils.rem(Border.Size.Small)} solid rgba(200, 200, 200, 0.16);
    `,
  },
  Ai: {
    Overview: {
      Background: Color.NeutralsFixed.Dark,
    },
    Tools: {
      Background: Color.Neutrals.Border,
    },
    ChatBubble: {
      Background: Color.Neutrals.Paper,
    },
    NewAIChat: {
      Disabled: Color.Neutrals.Border,
    },
  },
};

export const Button = {
  ...ThemeButton,
  Variant: {
    Outline: {
      Color: {
        Background: Color.Neutrals.Paper,
        Border: Color.Neutrals.Border,
        Content: Color.Neutrals.Dark,
      },
      Hover: {
        Background: Color.Neutrals.Paper,
        Content: Color.System.Primary,
      },
    },

    Secondary: {
      Color: {
        Background: Color.Neutrals.Light,
        Content: Color.Neutrals.Dark,
      },
      Hover: {
        Background: Color.Brand.Primary,
        Content: Color.Brand.Primary,
      },
    },
  },
};

export const Form = {
  ...ThemeForm,
  Input: {
    ...ThemeForm.Input,
    Placeholder: {
      Color: Color.Neutrals.Gray,
    },
  },

  Checkbox: {
    Color: {
      Background: Color.Overlay.Light,
    },
  },
};

export const Version = 'dark';

export const Modal = {
  ...ThemeModal,
  OverlayColor: Color.Overlay.Default,
};
